module.exports = __webpack_public_path__ + "media/bootstrap-icons/cart3-956f7609.svg";